import styled from "styled-components";
import { theme } from '../../../theme'
import { MdDone } from "react-icons/md";

const Item = styled.div`
  display: flex;
  align-items: center;
    padding: 1.9rem 3.7rem 1.9rem 1.2rem;
    border-bottom: 1px solid rgb(216 216 216 / 37%);
    justify-content: space-between;
`

const ImageTextContainer = styled.div`
    display: flex;
    align-items: center;
`

const ImageContainer = styled.div`
    width: 3.5rem;
    height: 3.5rem;
    color: ${theme.colors.mainBlue};
    background: rgba(33, 150, 243, 0.44);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
        height: 2.4rem;
        width: 2.4rem;
    }
`


const TextContainer = styled.div`
    margin-left:1.9rem;
    .assignment-title {
        font-weight: 600;
        font-size: 1.4rem;
        color: #3B3B42;
    }
    .assignment-date {
        font-size: 1.2rem;
        color: #979797;
    }
`

const ScoreContainer = styled.div`
    text-align: center;
    .total-score {
        font-weight: 700;
        font-size: 1.4rem;
        color: #3B3B42;
    }
    .score-text {
        font-weight: 700;
        font-size: 1.4rem;
        color: #979797;
    }
`

const SubmittedAssignmentsItem = () => {
    return (
        <Item>
            <ImageTextContainer>
                <ImageContainer>
                    <MdDone />
                </ImageContainer>
                <TextContainer>
                    <p className="assignment-title">Physics</p>
                    <p className="assignment-date">2 hours ago</p>
                </TextContainer>
            </ImageTextContainer>
            <ScoreContainer>
                <h3 className="total-score">9/10</h3>
                <p className="score-text">Score</p>
            </ScoreContainer>
        </Item>
    )
}

export default SubmittedAssignmentsItem
